import _ from "lodash";
import produce from "immer";

const SET_APP_PROCESSING = "application/SET_APP_PROCESSING";
const CLEAR_APP_PROCESSING = "application/CLEAR_APP_PROCESSING";

const SET_APP_SUCCESS = "application/SET_APP_SUCCESS";
const CLEAR_APP_SUCCESS = "application/CLEAR_APP_SUCCESS";

const SET_APP_ERROR = "application/SET_APP_ERROR";
const CLEAR_APP_ERROR = "application/CLEAR_APP_ERROR";

const CLEAR_ALL = "application/CLEAR_ALL";

// Example format of object for processing, success, and error
// {
//   context: "lib_account.retrieveAccountInformation" // optional string for context
//   notificationType: "alert", "toast", or "banner" but irrelevant for processing
//   title: "This is a title",
//   subtitle: "This is a subtitle",
//   message: "this is the message",
//   redirectPath: "/register", // automatically redirects
//   buttons: [
// {
//   label: "OK",
//   color: "primary",
//   onClick: ()  => { console.log("Clicked ok.")},
// }
//   ],
//   redirects: [
//     {
//       label: "Go to login",
//       path: "/auth"
//     }
//   ]
// }

const initialState = {
  processing: null,
  success: null,
  error: null,
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_APP_PROCESSING: {
        draft.processing = action.appState;
        draft.success = null;
        draft.error = null;
        break;
      }

      case CLEAR_APP_PROCESSING: {
        draft.processing = null;
        break;
      }

      case SET_APP_SUCCESS: {
        draft.processing = null;
        draft.success = action.appState;
        draft.error = null;
        break;
      }

      case CLEAR_APP_SUCCESS: {
        draft.success = null;
        break;
      }

      case SET_APP_ERROR: {
        draft.processing = null;
        draft.success = null;
        draft.error = action.appState;
        break;
      }

      case CLEAR_APP_ERROR: {
        draft.error = null;
        break;
      }

      case CLEAR_ALL: {
        draft.processing = null;
        draft.success = null;
        draft.error = null;
        break;
      }

      default: {
        break;
      }
    }
  });

export const setAppProcessing = (appState, history) => {
  return (dispatch) => {
    if (history && appState && appState.redirectPath) {
      history.push(appState.redirectPath);
    }

    dispatch({ type: SET_APP_PROCESSING, appState });
  };
};

export const clearAppProcessing = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_APP_PROCESSING });
  };
};

export const setAppSuccess = (appState, history) => {
  return (dispatch) => {
    if (history && appState && appState.redirectPath) {
      history.push(appState.redirectPath);
    }

    if (typeof appState.onSuccess === "function") {
      appState.onSuccess();
    }

    dispatch({ type: SET_APP_SUCCESS, appState });
  };
};

export const clearAppSuccess = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_APP_SUCCESS });
  };
};

export const setAppError = (appState, history) => {
  return (dispatch) => {
    if (history && appState && appState.redirectPath) {
      history.push(appState.redirectPath);
    }

    dispatch({ type: SET_APP_ERROR, appState });

    if (_.get(appState, "content.current")) {
      _.get(appState, "content.current").scrollToTop();
    }
  };
};

export const clearAppError = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_APP_ERROR });
  };
};

export const clearAll = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_ALL });
  };
};
